import { useTranslation } from 'react-i18next';

import { Avatar, NextImage, Typography } from '@/shared/components/atoms';

import Gallary from '~/images/shared/gallery.svg';

interface IdCardProps {
  backUrl?: string;
  frontUrl?: string;
}
export default function IdCard(props: IdCardProps) {
  const { backUrl, frontUrl } = props;
  const { t } = useTranslation('common');

  return (
    <div className='rounded-2xl border-xs border-neutralVariant-90 bg-background-neutral-99'>
      <div className='p-16'>
        <Typography variant='h3' weight='bold'>
          {t('national-id')}
        </Typography>
      </div>
      <div className='flex items-center justify-center gap-24 border-t-xs border-neutralVariant-90 p-24'>
        {!frontUrl || frontUrl?.includes('null') ? (
          <div className='flex min-h-[203px] w-full flex-col items-center justify-center rounded-xl bg-surface-0 px-16'>
            <Avatar
              icon={<Gallary />}
              size='xlg'
              className='bg-primary-200 text-primary-default'
            />
            <Typography weight='semiBold' variant='body1' className='mt-16'>
              {t('no-front-id-image')}
            </Typography>
          </div>
        ) : (
          <NextImage
            alt='frontID'
            src={frontUrl || ''}
            width={200}
            height={100}
          />
        )}
        {!backUrl || backUrl?.includes('null') ? (
          <div className='flex min-h-[203px] w-full flex-col items-center justify-center rounded-xl bg-surface-0 px-16'>
            <Avatar
              icon={<Gallary />}
              size='xlg'
              className='bg-primary-200 text-primary-default'
            />
            <Typography weight='semiBold' variant='body1' className='mt-16'>
              {t('no-back-id-image')}
            </Typography>
          </div>
        ) : (
          <NextImage
            alt='backID'
            src={backUrl || ''}
            width={200}
            height={100}
          />
        )}
      </div>
    </div>
  );
}
